export const colors = [
  'var(--color--curious-blue)',
  'var(--color--de-york)',
  'var(--color--marigold)',
  'var(--color--fuzzy-wuzzy-brown)',
  'var(--color--amethyst)',
  'var(--color--pine-glade)',
  'var(--color--nepal)',
  'var(--color--saffron)',
  'var(--color--mauvelous)',
  'var(--color--waikawa-gray)',
  'var(--color--anzac)',
  'var(--color--light-wisteria)',
  'var(--color--olivine)',
  'var(--color--sunglo)',
  'var(--color--danube)',
  'var(--color--pink-carnation)',
  'var(--color--malibu)',
  'var(--color--yellow-green)',
  'var(--color--pelorous)',
  'var(--color--geraldine)',
  'var(--color--portage)',
  'var(--color--chestnut-rose)',
  'var(--color--silver-tree)',
  'var(--color--indigo)',
  'var(--color--deep-blush)',
  'var(--color--viking)',
  'var(--color--wattle)',
  'var(--color--jungle-green)',
  'var(--color--cranberry)',
  'var(--color--twine)',
];
